export default __webpack_public_path__ + "static/media/Handbook.d34e7a09.pdf";